import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const vesselCrewRepository = AiseaApiFactory.get(
  "enterpriseManningVesselCrewResposibilities"
);

const EnterpriseManningVesselCrewReposibilitiesService = (() => {
  const fetch = async () => {
    const res = await vesselCrewRepository.fetch();
    if (!res || !res.status) throw res;
    return res.data;
  };
  const fetchList = async crew_id => {
    const res = await vesselCrewRepository.fetchList(crew_id);
    if (!res || !res.status) throw res;
    return res.data;
  };
  const update = async (crew_id, data) => {
    const res = await vesselCrewRepository.update(crew_id, data);
    if (!res || !res.status) throw res;
    return res.data;
  };
  return { fetch, fetchList, update };
})();

export default EnterpriseManningVesselCrewReposibilitiesService;
